
import React from 'react'
import SkeletonElement from '../../SkeletonElement'
import SkeletonGeneralOffer from '../SkeletonCategoryBar/SkeletonGeneralOffer'

function SkeletonDealPage({ isVisible }) {
  return (
    <div 
      className={`h-auto w-full transition-opacity duration-500 ${
        isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
    >
      {/* MOBILE */}
      <div className="flex md:hidden gap-x-6 pt-12 pb-7 animate-pulse">
        {[...Array(3).keys()].map((n) => (
          <SkeletonElement key={n} type="thumbnail" />
        ))}
      </div>
      {/* TABLET */}
      <div className="hidden md:flex lg:hidden gap-x-6 pt-12 pb-7 animate-pulse">
        {[...Array(6).keys()].map((n) => (
          <SkeletonElement key={n} type="thumbnail" />
        ))}
      </div>
      {/* WEB */}
      <div className="hidden lg:flex gap-x-6 pt-12 pb-7 animate-pulse">
        {[...Array(8).keys()].map((n) => (
          <SkeletonElement key={n} type="thumbnail" />
        ))}
      </div>
      {/* General Offers Skeleton */}
      <div id="DealsLoader" className="flex w-full gap-4 overflow-x-scroll">
        {[...Array(4).keys()].map((n) => (
          <SkeletonGeneralOffer key={n} shape="square" />
        ))}
      </div>
    </div>
  )
}

export default SkeletonDealPage;
